const TedInvitationSideBarCompanyIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66659 15.1693H3.33325C1.99992 15.1693 1.33325 14.5026 1.33325 13.1693V7.83594C1.33325 6.5026 1.99992 5.83594 3.33325 5.83594H6.66659V13.1693C6.66659 14.5026 7.33325 15.1693 8.66659 15.1693Z"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.73991 3.16406C6.68658 3.36406 6.66659 3.58406 6.66659 3.83073V5.83073H3.33325V4.4974C3.33325 3.76406 3.93325 3.16406 4.66659 3.16406H6.73991Z"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33325 5.83594V9.16927"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 5.83594V9.16927"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3333 11.8359H9.99992C9.63325 11.8359 9.33325 12.1359 9.33325 12.5026V15.1693H11.9999V12.5026C11.9999 12.1359 11.6999 11.8359 11.3333 11.8359Z"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 9.16406V11.8307"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66675 13.1693V3.83594C6.66675 2.5026 7.33341 1.83594 8.66675 1.83594H12.6667C14.0001 1.83594 14.6667 2.5026 14.6667 3.83594V13.1693C14.6667 14.5026 14.0001 15.1693 12.6667 15.1693H8.66675C7.33341 15.1693 6.66675 14.5026 6.66675 13.1693Z"
      stroke="#4583EC"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default TedInvitationSideBarCompanyIcon;
